module.exports = __webpack_public_path__ + "media/images/bnr-early-lg-a207dbc10ecea1491c1126ed1bc6738f.png";